module.exports = __webpack_public_path__ + "img/notice.bfdf731d.jpg";